export default __webpack_public_path__ + "static/media/splash.266e699a.gif";